module.exports = __webpack_public_path__ + "img/arrow-l.a25a6c55.svg";